import React from 'react'
import SavingImg1 from '../../Images/SavingImg/HealthSaving.jpg'
import SideNav from '../Navigation/SideNav'
import Aos from 'aos'

const HealthSaving = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    })

    return (
        <>

            <div className='main'>
                <div className='left-fixed'></div>
                <div className='d-body'>
                    <div className='d-body-nav' data-aos='fade-right'>
                        <SideNav />
                    </div>
                    <div className='d-body-main' data-aos='fade-right'>
                        <div className='saving-body-top'>
                            <h2>स्वास्थ्य बचत</h2>
                        </div>
                        <div className='saving-body'>
                            <div className='saving-main'>
                                <h3>विशेषताहरू :</h3>
                                <p>
                                    <ul>
                                        <li>सदस्यको चाहना अनुरूप मासिक पाक्षिक र साप्ताहिक रूपमा जम्मा गर्न सकिने । </li>
                                        <li>स्वास्थ्य जाँच गरेको कागजात पेश गरेपछि भुक्क्तानी गरिने । </li>
                                        <li>तत्काल बिरामी परेमा आकस्मिक ऋण उपलब्ध गराउन सकिने ।</li>
                                        <li>स्वेच्छिक रूपमा खाता बन्द गर्न सकिने ।</li>
                                        <li>ब्याजलाई संरक्षित पूँजी फिर्ता कोष वितरणमा गणना गरिने । </li>
                                        <li>उत्कृष्ट बचत कर्तालाई पुरस्कार तथा सम्मान प्रदान गरिने । </li>
                                        <li>खातामा न्युनतम मौज्दात रु २००।– राखि बाँकी फिर्ता लान सकिनेछ ।</li>
                                    </ul>
                                </p>
                            </div>
                            <div className='savingimg'>
                                <img src={SavingImg1} alt='saving-1' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default HealthSaving